import React from 'react';
import { cn } from '../../lib/utils';

export function PendingCard({ total, fixtures = [], className }) {
  if (total == null) return null;

  return (
    <aside
      className={cn(
        'rounded-xl border border-amber-200 bg-[#F8F1E3] px-4 py-3 text-amber-950 shadow-sm',
        className
      )}
    >
      <p className="font-display text-[10px] font-bold uppercase tracking-[0.14em] text-amber-800">
        Pending
      </p>
      <p className="mt-1 text-2xl font-bold tabular-nums tracking-tight">
        {total.toLocaleString('en-US')}
      </p>
      <p className="mt-0.5 text-[11px] text-amber-900/80">
        Held out of conversion · not drop-off
      </p>
      {fixtures.length > 0 ? (
        <ul className="mt-3 space-y-1.5 border-t border-amber-200/80 pt-2.5">
          {fixtures.slice(0, 3).map((fixture) => (
            <li
              key={fixture.id}
              className="flex justify-between gap-2 text-[11px] leading-snug"
            >
              <span className="min-w-0 truncate">{fixture.label}</span>
              <span className="shrink-0 font-semibold tabular-nums">
                {fixture.count.toLocaleString('en-US')}
              </span>
            </li>
          ))}
        </ul>
      ) : null}
    </aside>
  );
}
